module.exports = __webpack_public_path__ + "static/media/banner.6b093986.png";